document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.ghc-product-form')) return;
  event.preventDefault();
  const button = form.querySelector('[name="add"]');
  if (!button || button.disabled) return;
  button.disabled = true;
  let error = form.querySelector('[role="alert"]');
  if (!error) { error = document.createElement('p'); error.setAttribute('role','alert'); error.className='ghc-form-error'; form.append(error); }
  error.textContent = '';
  try {
    const data = new FormData(form);
    const response = await fetch(form.action + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
    window.location.assign(data.get('return_to') || (window.Shopify?.routes?.root || '/') + 'cart');
  } catch (problem) { error.textContent = problem.message; button.disabled = false; }
});
